const transformSeconds = seconds => Math.ceil(seconds / 60)

/**
 * 转换课程表课程状态
 * @param { Number } isFinished 是否已经学习完 0: 未看完， 1: 看完
 * @param { Number } learnLength 已学习时长 unit: s
 * @param { Number } videoLength 总时长 unit: s
 */
export default (isFinished, learnLength, videoLength) => {
  let status = ''

  if (isFinished === 1) {
    status = '已学习'
  } else {
    if (learnLength) {
      // 判断学习时长占比
      const _l = transformSeconds(learnLength)
      const _t = transformSeconds(videoLength)

      if (Math.floor((_l / _t) * 10) > 9) {
        status = '已学习'
      } else {
        status = `已学习${_l}分钟/共${_t}分钟`
      }
    } else {
      status = '未学习'
    }
  }

  return status
}
